import App from 'app/app.js';
import template from './accordion.html';
import './accordion.scss';

class AccordionController {
  open = true;

  $onInit() {
    if (this.open === undefined) {
      this.open = true;
    }
  }

  toggleAccordion() {
    this.open = !this.open;

    if (this.onToggle) {
      this.onToggle();
    }
  }
}
App.component('ltAccordion', {
  template,
  bindings: {
    step: '<',
    caption: '<',
    desc: '<',
    customClass: '<',
    open: '=?',
    onToggle: '&?'
  },
  transclude: true,
  controller: AccordionController,
  controllerAs: 'accordion'
});
